import { render, staticRenderFns } from "./ProgressEmpty.vue?vue&type=template&id=484ead1e&scoped=true&"
import script from "./ProgressEmpty.vue?vue&type=script&lang=js&"
export * from "./ProgressEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ProgressEmpty.vue?vue&type=style&index=0&id=484ead1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ead1e",
  null
  
)

export default component.exports